import { gsap } from "gsap";
import DrawSVGPlugin from "gsap/DrawSVGPlugin";
import TextPlugin from "gsap/TextPlugin";

gsap.registerPlugin(TextPlugin, DrawSVGPlugin);

export default function teamEnterDesktop(data, isMobile, isTouch) {
  if(isMobile) {
    return gsap
    .timeline()
    .set(".wipe-wrapper", {
      autoAlpha: 0,
    })
    .set(data.next.container, {
      autoAlpha: 1,
    })
    .set(".hide-on-load", {
      autoAlpha: 1,
    })
    .from(
      ".team-archive__hero h1",
      {
        autoAlpha: 0, 
        xPercent: -20,
        ease: "none",
      },
      "<50%"
    )
    .from(".team-archive__hero p", {
      xPercent: -20,
      autoAlpha: 0,
      delay: 0.25,
    })
    .from(".team-archive__list--item", {
      autoAlpha: 0,
      yPercent: -20,
      stagger: 0.15,
    })
    .from(
      ".team-archive__hero--coord",
      {
        autoAlpha: 0,
      },
      "<"
    )
    // .from(
    //   ".team-archive__hero--coord .coord--line",
    //   {
    //     width: 0,
    //   },
    //   "<50%"
    // )
  }
  return (
    gsap
      .timeline()
      .set(".wipe-wrapper", {
        autoAlpha: 0,
      })
      .set(data.next.container, {
        autoAlpha: 1,
      })
      .set(".hide-on-load", {
        autoAlpha: 1,
      })
      .set(".team-archive__hero--coord svg path", {
        drawSVG: "0%",
      })
      .from(
        ".team-archive__hero h1",
        {
          autoAlpha: 0, 
          xPercent: -50,
          duration: 0.5, 
        },
        "<50%"
      )
      .from(".team-archive__hero p", {
        xPercent: -20,
        autoAlpha: 0,
        delay: document.querySelector(".team-archive__hero p") ? 0.25 : 0,
        duration: document.querySelector(".team-archive__hero p") ?  0.5 : 0,
      })
      .from(".team-archive__list--item", {
        autoAlpha: 0,
        yPercent: -20,
        stagger: 0.15,
      })
      .from(
        ".team-archive__hero--coord",
        {
          autoAlpha: 0,
        },
        "<"
      )
      .from(
        ".team-archive__hero--coord .coord--line",
        {
          width: 0,
        },
        "<50%"
      )
      .fromTo(
        ".team-archive__hero .bp .draw-on-load",
        {
          drawSVG: "0%",
        },
        {
          drawSVG: "100%",
          duration: 3,
        },
        "<"
      )
  );
}
